var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Music = function Music(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.626 3.22A1 1 0 0 1 19 4v11.5a3.5 3.5 0 1 1-2-3.163v-7.09l-7 1.555V17c0 .06-.005.117-.015.174A3.5 3.5 0 1 1 8 14.337V6a1 1 0 0 1 .783-.976l9-2a1 1 0 0 1 .843.196ZM15.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM8 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Music;